<template>
  <v-dialog v-model="dialog" max-width="720">
    <v-card class="dialog-stati-mercati-card">
      <v-card-title class="navy darken-1 white--text">
        Stato mercati
        <v-spacer />
        <v-btn depressed class="white--text" light icon @click="dismiss">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-4">
        <v-alert
          v-if="isMercatoAstaLiveNonAttivo"
          type="warning"
          dense
          outlined
          class="alert-hint mb-4"
        >
          Per avviare <b>Asta Live</b> l'{{ adminLegaDivisioneLabel }} deve prima
          impostare su <b>ATTIVO</b> questo tipo di mercato.
        </v-alert>

        <v-alert v-if="error" type="error" dense outlined class="mb-4">
          {{ error }}
        </v-alert>

        <v-simple-table dense class="mercati-table">
          <!-- <thead>
            <tr>
              <th class="text-left navy--text">Mercato</th>
              <th class="text-left navy--text">Stato</th>
            </tr>
          </thead> -->
          <tbody>
            <tr v-if="loading">
              <td colspan="2" class="py-4 text-center">
                Caricamento...
              </td>
            </tr>
            <tr v-if="mercatoAstaLive">
              <td class="mercato-cell">
                <div class="mercato-title">
                  <img
                    v-if="mercatoIcon(mercatoAstaLive)"
                    class="mercato-icon"
                    :src="mercatoIcon(mercatoAstaLive)"
                    alt=""
                  />
                  <span>{{ mercatoAstaLive.text }}</span>
                </div>
              </td>
              <td class="mercato-select-cell">
                <stato-mercato-select
                  :key="statoMercatoSelectKey(mercatoAstaLive)"
                  :class="{
                    'asta-live-status-select': shouldPulseMercato(mercatoAstaLive)
                  }"
                  :value="mercatoAstaLive.statoMercato"
                  :tipo-mercato="mercatoAstaLive"
                  :disabled="loading || isSaving(mercatoAstaLive)"
                  :loading="isSaving(mercatoAstaLive)"
                  @change="save(mercatoAstaLive, $event)"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div v-if="!loading && altriMercati.length > 0" class="mercati-section-title navy--text">
          Altri tipi di aste
        </div>

        <v-simple-table
          v-if="!loading && altriMercati.length > 0"
          dense
          class="mercati-table"
        >
          <tbody>
            <tr v-for="mercato in altriMercati" :key="mercato.id">
              <td class="mercato-cell">
                <div class="mercato-title">
                  <img
                    v-if="mercatoIcon(mercato)"
                    class="mercato-icon"
                    :src="mercatoIcon(mercato)"
                    alt=""
                  />
                  <span>{{ mercato.text }}</span>
                </div>
              </td>
              <td class="mercato-select-cell">
                <stato-mercato-select
                  :key="statoMercatoSelectKey(mercato)"
                  :value="mercato.statoMercato"
                  :tipo-mercato="mercato"
                  :disabled="loading || isSaving(mercato)"
                  :loading="isSaving(mercato)"
                  @change="save(mercato, $event)"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Vuex from "vuex";
import db from "../../js/db";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import * as api from "../../js/api";
import * as Helpers from "../../js/helpers";
import Constants from "../../js/constants";
import StatoMercatoSelect from "../common/StatoMercatoSelect";

export default {
  name: "dialog-stati-mercati",
  mixins: [mixins, toast],
  components: {
    StatoMercatoSelect,
  },
  data() {
    return {
      dialog: false,
      error: "",
      loading: false,
      mercati: [],
      savingByMercatoId: {},
      selectVersionByMercatoId: {},
    };
  },
  mounted() {
    console.log("--> DialogStatiMercati ready.");
    db.on("showStatiMercati", this.show);
  },
  destroyed() {
    console.log("<-- DialogStatiMercati destroyed.");
    db.off("showStatiMercati", this.show);
  },
  methods: {
    show() {
      this.dialog = true;
      this.loadMercati();
    },
    dismiss() {
      this.dialog = false;
    },
    isSaving(mercato) {
      return !!this.savingByMercatoId[mercato.id];
    },
    shouldPulseMercato(mercato) {
      return (
        mercato.id == Constants.TIPO_MERCATO_ASTA_LIVE &&
        mercato.statoMercato == Constants.MERCATO_NON_ATTIVO
      );
    },
    mercatoIcon(mercato) {
      const mercatiConIcona = [
        Constants.TIPO_MERCATO_ASTA_LIVE,
        Constants.TIPO_MERCATO_ASTA_AUTOMATICA,
        Constants.TIPO_MERCATO_ASTA_EBAY,
      ];
      const mercatoId = parseInt(mercato && mercato.id);
      return mercatiConIcona.includes(mercatoId)
        ? `/static/img/icon_TIPO_MERCATO_${mercatoId}.png`
        : "";
    },
    statoMercatoSelectKey(mercato) {
      return `${mercato.id}-${mercato.statoMercato}-${this.selectVersionByMercatoId[mercato.id] || 0}`;
    },
    resetStatoMercatoSelect(mercato) {
      this.$set(
        this.selectVersionByMercatoId,
        mercato.id,
        (this.selectVersionByMercatoId[mercato.id] || 0) + 1
      );
    },
    loadMercati() {
      if (!this.asta_info || !this.asta_info.lega) {
        this.error = "Informazioni lega non disponibili";
        return;
      }

      this.error = "";
      this.loading = true;
      api
        .getTipiMercatiLega(this.asta_info.lega.ID_Lega)
        .then((mercati) => {
          this.mercati = mercati;
        })
        .catch((err) => {
          this.error = err && err.message
            ? `Stati mercato non disponibili: ${err.message}`
            : "Stati mercato non disponibili";
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save(mercato, statoMercato) {
      if (mercato.statoMercato == statoMercato) {
        return;
      }

      if (
        Helpers.isLocalRuntime() &&
        (!this.user_claims.fp_uid || !this.user_claims.fp_sessid)
      ) {
        this.errorToast("Errore", "Sessione utente non pronta");
        this.resetStatoMercatoSelect(mercato);
        return;
      }

      this.$set(this.savingByMercatoId, mercato.id, true);
      api
        .saveStatoMercato({
          uid: this.user_claims.fp_uid,
          sessid: this.user_claims.fp_sessid,
          os: this.user_claims.os,
          ID_Lega: this.asta_info.lega.ID_Lega,
          ID_Divisione: this.asta_info.lega.ID_Divisione,
          tipoMercato: mercato.id,
          statoMercato,
        })
        .then(() => {
          mercato.statoMercato = parseInt(statoMercato);
          const statoMercatoText = Helpers.statoMercatoText(
            mercato,
            mercato.statoMercato
          );
          this.successToast(`${mercato.text}: ${statoMercatoText}`, "");
        })
        .catch((err) => {
          this.resetStatoMercatoSelect(mercato);
          this.errorToast(
            "Errore",
            err && err.message
              ? `Stato mercato non aggiornato: ${err.message}`
              : "Stato mercato non aggiornato"
          );
          console.error(err);
        })
        .finally(() => {
          this.$delete(this.savingByMercatoId, mercato.id);
        });
    },
  },
  computed: {
    mercatoAstaLive() {
      return this.mercati.find(
        (mercato) => mercato.id == Constants.TIPO_MERCATO_ASTA_LIVE
      );
    },
    altriMercati() {
      const mercatiNascosti = [
        Constants.TIPO_MERCATO_ASSEGNA_SVINCOLA,
        Constants.TIPO_MERCATO_SCAMBI,
      ];
      return this.mercati.filter(
        (mercato) =>
          mercato.id != Constants.TIPO_MERCATO_ASTA_LIVE &&
          !mercatiNascosti.includes(parseInt(mercato.id))
      );
    },
    isMercatoAstaLiveNonAttivo() {
      return (
        this.asta_info &&
        this.asta_info.statoMercato == Constants.MERCATO_NON_ATTIVO
      );
    },
    ...Vuex.mapGetters(["asta_info", "user_claims"]),
  },
};
</script>

<style scoped>
.mercato-cell {
  width: 62%;
  padding-bottom: 12px !important;
  padding-top: 12px !important;
}

.dialog-stati-mercati-card {
  background: var(--v-navy-darken2);
  color: white;
}

.dialog-stati-mercati-card >>> .v-card__text {
  color: white;
}

.mercati-table {
  background: transparent !important;
  color: white;
}

.mercati-table >>> table,
.mercati-table >>> thead,
.mercati-table >>> tbody,
.mercati-table >>> tr,
.mercati-table >>> th,
.mercati-table >>> td {
  background: transparent !important;
}

.mercato-title {
  align-items: center;
  color: white;
  display: flex;
  font-weight: 700;
  gap: 10px;
  line-height: 1.2;
  text-transform: uppercase;
}

.mercato-icon {
  display: block;
  flex: 0 0 auto;
  height: 28px;
  object-fit: contain;
  width: 28px;
}

.mercato-description {
  color: var(--v-text-base);
  font-size: 12px;
  line-height: 1.2;
}

.mercato-select-cell {
  width: 38%;
  max-width: 240px;
  padding-bottom: 12px !important;
  padding-top: 12px !important;
}

.mercati-section-title {
  color: white;
  font-size: 13px;
  font-weight: 700;
  margin: 18px 0 6px;
  text-transform: uppercase;
}

.mercati-table >>> tbody tr:hover {
  background: transparent !important;
}

.mercati-table >>> .v-input__slot {
  background: var(--v-navy-darken1) !important;
}

.mercati-table >>> .v-input__slot fieldset {
  border: none !important;
}

.mercati-table >>> .v-select__selection,
.mercati-table >>> .v-icon {
  color: white !important;
}

.asta-live-status-select >>> .v-input__slot {
  animation: pulsante 1.25s infinite;
  border-radius: 4px;
  box-shadow: 0 0 0 0 var(--v-navy-base);
}

@media (max-width: 600px) {
  .mercati-table >>> th,
  .mercati-table >>> td {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .mercato-cell {
    width: 50%;
    padding-bottom: 6px !important;
    padding-top: 6px !important;
  }

  .mercato-select-cell {
    width: 50%;
    max-width: none;
    padding-bottom: 6px !important;
    padding-top: 6px !important;
  }

  .mercato-title {
    font-size: 13px;
    line-height: 1.15;
  }

  .mercato-icon {
    height: 24px;
    width: 24px;
  }

  .mercati-section-title {
    font-size: 12px;
    margin-top: 12px;
  }

  .mercati-table >>> .v-input__slot {
    min-height: 34px !important;
  }

  .mercati-table >>> .v-select__selection {
    font-size: 13px;
  }

  .mercati-table >>> .v-select__slot input {
    display: none;
  }
}
</style>
